import {Input} from "../types/Input";
import {createSlice} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'

interface ValidateDataProps {
    inputs: Input[],
    introducedData: object,
    callback?: (b: boolean) => void
}

interface ValidateFieldProps {
    input: Input,
    value: object,
    callback?: (b: boolean) => void
}

export interface ValidationDataActionProps {
    payload: ValidateDataProps,
}

interface ValidationFieldActionProps {
    payload: ValidateFieldProps,
}

interface ValidationState {
    errors: Record<string, string>,
    valid: boolean
}

const initialValidationState: ValidationState = {
    errors: {},
    valid: true,
}

const validate = (inputs: Input[], data: object): Record<string, string> => {
    const errors: Record<string, string> = {};
    for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];
        if (input && (!Object.keys(data).includes(input.key) || typeof data[input.key] === "undefined" || data[input.key] === null || data[input.key].length === 0) && (!input.depends || input.show_when === data[input.depends])) {
            errors[input.key] = input.label + ' is required';
        } else {
            if (input && input.regex) {
                const regex = new RegExp(input.regex);
                if (!regex.test(data[input.key])) {
                    errors[input.key] = input.label + ' has invalid format';
                }
            }
        }

    }

    return errors;
}

export const validationSlice = createSlice({
    name: 'validation',
    initialState: initialValidationState,
    reducers: {
        clear: (state) => {
            state.errors = {};
            state.valid = true;
        },
        validateData: (state, action: PayloadAction<ValidationDataActionProps>) => {
            console.log(action.payload.payload.inputs, action.payload.payload.introducedData);
            state.errors = validate(action.payload.payload.inputs, action.payload.payload.introducedData);
            state.valid = Object.keys(state.errors).length === 0;
            if (action.payload.payload.callback) {
                action.payload.payload.callback(state.valid);
            }
        },
        validateInput: (state, action: PayloadAction<ValidationFieldActionProps>) => {
            state.errors = validate([action.payload.payload.input], action.payload.payload.value);
            state.valid = Object.keys(state.errors).length === 0;
            if (action.payload.payload.callback) {
                action.payload.payload.callback(state.valid);
            }
        },
        setErrors: (state, action: PayloadAction<ValidationState>) => {
            state.errors = action.payload.errors;
            state.valid = action.payload.valid;
        }
    }
})

export const {validateData, validateInput, clear, setErrors} = validationSlice.actions
export default validationSlice.reducer
